(function () {
  const mainButtons = document.querySelectorAll('.size-guide__button');

  if (mainButtons.length === 0) return;

  document.addEventListener('productoptions.appLoad', (event) => {
    mainButtons.forEach((mainButton) => {
      if (!mainButton.dataset.keywords) return;

      const keywords = mainButton.dataset.keywords.split(',').map((keyword) => keyword.toLowerCase());

      if (keywords.length === 0) return;

      const fields = event.detail.fields;
      // should be an array of arrays, where each inner array represents a field set
      if (!Array.isArray(fields) || fields.length === 0) return;

      const firstFieldSet = fields[0];

      if (!firstFieldSet) return;

      // Get first selectable field
      const selectFields = firstFieldSet.filter(
        (field) =>
          field.type === 'combo_select' ||
          field.type === 'select' ||
          field.type === 'combo_image' ||
          field.type === 'swatch_select_image',
      );

      if (selectFields.length === 0) return;


      // Get the first field that matches the keywords by label_product field
      const firstField = selectFields.find((field) => {
        const labelProduct = field.label_product ? field.label_product.toLowerCase() : '';
        return keywords.some((keyword) => labelProduct.includes(keyword));
      });

      if (!firstField) return;

      const fieldKey = firstField.key;

      if (!fieldKey) return;

      const firstOption = document.querySelector(`
        .avp-option[key="${fieldKey}"] .ap-label-tooltip
    `);

      if (!firstOption) return;

      // Check if the button is already inside to avoid duplicating
      if (!firstOption.contains(mainButton)) {
        firstOption.appendChild(mainButton);
      }

      // Ensure it is visible (if it was hidden before)
      mainButton.style.display = '';
    });
  });
})();
